import Oidc from 'oidc-client';

const isDev = process.env.VUE_APP_ENV === 'development';
if (isDev) Oidc.Log.logger = console;

const ID_SERVER = process.env.VUE_APP_ID_URL || 'https://flex-id.xcentium.com';
const APP_URL = `${ window.location.protocol }//${ window.location.host }`;

const mgr = new Oidc.UserManager({
    authority: ID_SERVER,
    client_id: 'Flex',
    redirect_uri: `${ APP_URL }/callback`,
    response_type: 'id_token token',
    scope: 'openid flex.profile sitecore.profile sitecore.profile.api',
    post_logout_redirect_uri: ID_SERVER,
});

export default mgr;
